export const filialSearch = {
  label: 'Filial',
  placeholder: 'ID ou Identificação...',
  titulo: 'Buscar Filial',
  endpointApi: 'Filiais',
  idField: 'idFilial',
  displayField: 'idFilial',
  descField: 'identificacao',
  colunasGrid: [
    { header: 'ID', dataField: 'idFilial', width: '80px' },
    { header: 'Identificação', dataField: 'identificacao', width: '250px' },
    { header: 'Cidade', dataField: 'cidade', width: '200px' },
    { header: 'UF', dataField: 'uf', width: '80px' },
    { header: 'CNPJ', dataField: 'cnpj', width: '150px' }
  ]
}
